import PanelTemplate from "components/shared/profile/panel";
import { canManageOrganization } from "helpers/system";
import React from "react";
import { config, initialState } from "./config";

class BankInfo extends PanelTemplate {
    handleBankChange = ({ value, option }) => {
        const data = option
            ? {
                  ...this.state.data,
                  bank: option.bank || "",
                  bankId: option.bic || value || "",
              }
            : {
                  ...this.state.data,
                  bank: "",
                  bankId: value || "",
              };
        const shouldUpdate = this.compareStateAndProps(this.props.data, data);
        const isValid = this.isValidForm(data);
        this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    renderBody = () => {
        const { editable, config, roles } = this.props;
        const { inn, kpp, ogrn, bank, ks, rs, bankId } = config;
        const { isTruckingOrganizationAdmin } = roles;
        return (
            <div className="row">
                <div className="col-sm-4">
                    <h5>Реквизиты</h5>
                </div>
                <div className="col-sm-8">
                    {canManageOrganization(roles) && this.renderField({ ...inn, disabled: !editable })}
                    {this.renderField({ ...kpp, disabled: !editable })}
                    {this.renderField({ ...ogrn, disabled: !editable })}
                    {isTruckingOrganizationAdmin
                        ? this.renderSelect({ ...bankId, disabled: !editable, onChange: this.handleBankChange })
                        : this.renderField({ ...bankId, disabled: true })}
                    {this.renderField({ ...bank, disabled: !editable })}
                    {this.renderField({ ...ks, disabled: !editable })}
                    {this.renderField({ ...rs, disabled: !editable })}
                </div>
            </div>
        );
    };
}

const ConfiguredPanel = (props) => <BankInfo {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
